'use client';

const defaultProps = {
  iconPosition: "end",
  size: "md",
  variant: "default"
};
export {
  defaultProps
};
